export const TEAM_SPACE_TABS = {
  CURRENT: 'current',
  COMPLETED: 'completed',
  TREND: 'trend'
};

export const TEAM_SPACE_STORAGE_KEYS = {
  TEAM_ID: 'TEAM_SPACE_TEAM_ID',
  TAB: 'TEAM_SPACE_TAB'
};
